
document.addEventListener('DOMContentLoaded', ()=>{

    const body = document.body;

    const modal = document.getElementById('modal');

    const closePopupButton = document.getElementById('closePopUp');
    const modalTriggers = document.querySelectorAll('.appointment-button');


    modalTriggers.forEach(modalTrigger => {
        modalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            body.classList.add('no-scroll')
            modal.classList.add('active');
        });
    });

    closePopupButton.addEventListener('click', ()=>{
        modal.classList.remove('active');
        body.classList.remove('no-scroll')
    })

});